import * as React from 'react';
import { SyncOutlined } from '@ant-design/icons';
import { Input, Col } from 'antd';
import { imgCode } from 'common/api';
import Loading from 'common/components/Loading/index';
const InputGroup = Input.Group;

interface Iprops {
    refreshCallback?: Function;
    height?: number;
    width?: number;
    value?: string;
    placeholder?: string;
    inputChange?: (payload: object) => void;
    onChange?: (payload: object) => void;
    remoteValidate?: (payload: any) => void;
    onBlur?: (payload: object) => void;
}
interface Istate {
    isLoading: boolean;
    inputValue: string;
}

export default class ImgCode extends React.Component<Iprops, Istate> {

    height: number;
    _t: any;
    width: number;
    verticalAlign: number;
    iconWidth: number;
    svg: string;
    key: string;

    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true,
            inputValue: ''
        };
        this.height = 45;
        this.iconWidth = 14;
        this.width = 140 - this.iconWidth;
        let { height, width } = this.props;
        if (height && typeof height === 'number') {
            this.height = height;
        }
        if (width && typeof width === 'number') {
            this.width = width - this.iconWidth;
        }
        this.verticalAlign = (((this.height - this.iconWidth) / 2) - 2) * -1;
    }

    componentDidUpdate() {
        // 添加对图形验证码错误后自动刷新的支持
        // 需要指定 form.setFieldsValue({imgcode:'reset'})
        if (this.props.value === 'reset') {
            this.handleReGet();
        }
    }

    getCode = async () => {
        let { svg, key } = await imgCode.getCode({
            width: this.width, height: this.height
        });
        this.svg = svg;
        this.key = key;
        this.setState({ isLoading: false });
    }

    componentDidMount() {
        this.getCode().catch(err => console.error(err));
    }

    inputChange = (e: any) => {
        let targetValue = e.target.value;
        this.setState({ inputValue: targetValue });
        if (targetValue && this.props.remoteValidate) {
            clearTimeout(this._t);
            this._t = setTimeout(async () => {
                let data = await imgCode.verifyCode({
                    key: this.key, imgcode: targetValue
                });
                this.props.remoteValidate(data);
            }, 300);
        }
        this.props.inputChange && this.props.inputChange({
            key: this.key,
            imgcode: targetValue
        });
    }

    changeHandle = (e: any) => {
        let targetValue = e.target.value;
        this.props.onChange && this.props.onChange({
            key: this.key,
            value: targetValue
        });
    };

    handleReGet = () => {
        this.props.refreshCallback && this.props.refreshCallback();
        let mockEvent = { target: { value: '' } };
        this.changeHandle(mockEvent);
        this.inputChange(mockEvent);
        this.setState({ isLoading: true, inputValue: '' });
        this.getCode().catch(err => console.error(err));
    };

    inputOnBlur = (e: any) => {
        let targetValue = e.target.value;
        this.props.onBlur && this.props.onBlur({
            key: this.key,
            value: targetValue
        });
    }

    render() {
        let { placeholder } = this.props;
        let { isLoading, inputValue } = this.state;
        return (
            <InputGroup>
                <Col span={14} style={{ paddingTop: `${this.height - 32}px` }}>
                    <Input placeholder={placeholder} onChange={this.changeHandle} onInput={this.inputChange} value={inputValue} onBlur={this.inputOnBlur} />
                </Col>
                <Col span={10}>
                    <Loading enabled={isLoading}>
                        <div onClick={this.handleReGet} style={{ cursor: 'pointer' }}>
                            <SyncOutlined
                                className="auth-icon-rotate"
                                style={{ color: '#5992c8', verticalAlign: `middle` }} />
                            <div dangerouslySetInnerHTML={{ __html: isLoading ? '' : this.svg }}
                                style={{ width: '50px', verticalAlign: 'middle', display: 'inline-block', height: `${this.height}px` }}></div>
                        </div>
                    </Loading>
                </Col>
            </InputGroup>
        );
    }

}
